/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.kit.KitSignatureStatus
*/
export var KitSignatureStatus;
(function (KitSignatureStatus) {
    KitSignatureStatus["VERIFIED"] = "VERIFIED";
    KitSignatureStatus["UNSIGNED"] = "UNSIGNED";
    KitSignatureStatus["FAILED"] = "FAILED";
})(KitSignatureStatus || (KitSignatureStatus = {}));
//# sourceMappingURL=KitSignatureStatus.js.map